import classNames from 'classnames';
import AvenueGatsbyImage from '../common/AvenueGatsbyImage';

export function FeatureCard({ icon, title, description, buttonText, buttonColor, cta }) {
    return (
        <div
            className={classNames(
                'flex flex-col justify-between rounded-lg bg-avenue-slate-500 p-12 text-white delay-150 duration-300 ease-in-out',
                'hover:-translate-y-1 hover:scale-110',
            )}
        >
            <div>
                <div className='mx-auto mb-4 h-10 w-10 rounded-full'>
                    <AvenueGatsbyImage localFile={icon} title='Icon' />
                </div>

                <h2 className='mx-auto text-center text-4xl tracking-tighter text-avenue-blue-500 md:max-w-md'>
                    {title}
                </h2>
            </div>

            <div className='mx-auto my-8 max-w-lg text-center text-lg'>{description}</div>

            {cta && (
                <a
                    href={cta}
                    type='button'
                    className={classNames(
                        'mt-auto self-center whitespace-nowrap rounded-md px-8 py-4 text-lg font-bold tracking-normal shadow-md',
                        buttonColor === 'blue' && 'bg-avenue-blue-500',
                        buttonColor === 'orange' && 'bg-avenue-orange-500',
                        !buttonColor && 'bg-avenue-blue-500',
                    )}
                    aria-label='Apply now'
                    target='_self'
                    rel='noreferrer'
                >
                    {buttonText}
                    <span className='tracking-normal text-white'> →</span>
                </a>
            )}
        </div>
    );
}
